
import { filterMatchesByOddsRange } from './helpers';

/**
 * Calculate average goals stats for an odds range
 */
export const calculateGoalsAverageForOddsRange = (
  matches: any[], 
  range: { min: number, max: number }, 
  oddsType: 'home' | 'away'
): { homeAvg: number, awayAvg: number, totalAvg: number } => {
  const matchesInRange = filterMatchesByOddsRange(matches, range, oddsType);
  
  if (matchesInRange.length === 0) {
    return { homeAvg: 0, awayAvg: 0, totalAvg: 0 };
  }
  
  let totalHomeGoals = 0;
  let totalAwayGoals = 0;
  
  matchesInRange.forEach(match => {
    // Parse goal values, ensuring we handle string or number inputs
    const homeGoals = typeof match.FTHG === 'string' ? parseInt(match.FTHG) : match.FTHG || 0;
    const awayGoals = typeof match.FTAG === 'string' ? parseInt(match.FTAG) : match.FTAG || 0;
    
    totalHomeGoals += homeGoals;
    totalAwayGoals += awayGoals;
  });
  
  const matchCount = matchesInRange.length;
  const homeAvg = totalHomeGoals / matchCount;
  const awayAvg = totalAwayGoals / matchCount;
  const totalAvg = (totalHomeGoals + totalAwayGoals) / matchCount;
  
  return {
    homeAvg,
    awayAvg,
    totalAvg
  };
};

/**
 * Calculate over/under 2.5 goals percentages
 */
export const calculateOverUnderGoalsForOddsRange = (
  matches: any[],
  range: { min: number, max: number },
  oddsType: 'home' | 'away'
): { over25Percent: number, under25Percent: number } => {
  const matchesInRange = filterMatchesByOddsRange(matches, range, oddsType);
  
  if (matchesInRange.length === 0) {
    return { over25Percent: 0, under25Percent: 0 };
  }
  
  // Count matches where total goals > 2.5
  const over25Matches = matchesInRange.filter(match => {
    // Parse goal values, ensuring we handle string or number inputs
    const homeGoals = typeof match.FTHG === 'string' ? parseInt(match.FTHG) : match.FTHG || 0;
    const awayGoals = typeof match.FTAG === 'string' ? parseInt(match.FTAG) : match.FTAG || 0;
    
    return homeGoals + awayGoals > 2.5;
  }).length;
  
  // Calculate percentages
  const matchCount = matchesInRange.length;
  const over25Percent = (over25Matches / matchCount) * 100;
  const under25Percent = ((matchCount - over25Matches) / matchCount) * 100;
  
  return {
    over25Percent,
    under25Percent
  };
};
